/**
 * Идентификатор P2P-треда в Firestore: два invite-токена в лексикографическом порядке через "__".
 * Тот же порядок хранится в документе треда как **`participantInviteTokens`** [a,b] для правил доступа.
 */
export function p2pThreadIdFromSortedTokens(sortedA: string, sortedB: string): string {
  return `${sortedA}__${sortedB}`;
}

export function p2pThreadId(inviteTokenA: string, inviteTokenB: string): string {
  const [a, b] = [inviteTokenA, inviteTokenB].sort();
  return p2pThreadIdFromSortedTokens(a, b);
}

/**
 * Разбор id треда; null если не каноническая отсортированная пара (токены не должны содержать "__").
 */
export function parseSortedThreadInviteTokens(threadId: string): [string, string] | null {
  const parts = threadId.split('__');
  if (parts.length !== 2 || !parts[0] || !parts[1]) return null;
  const [a, b] = [parts[0], parts[1]].sort();
  if (p2pThreadIdFromSortedTokens(a, b) !== threadId) return null;
  return [a, b];
}
